module.exports = __webpack_public_path__ + "img/work-desbravando.1f69d95f.png";